import ArticleLayout from '@/components/feature/ArticleLayout';
import ArticleJsonLd from '@/components/feature/ArticleJsonLd';

export default function Art6() {
  return (
    <>
      <ArticleJsonLd
        headline="Atualizações do HoobuySpreadsheet em 2026: O Que Mudou e Melhorou"
        description="Fique por dentro de todas as atualizações e melhorias do Hoobuy Spreadsheet em 2026. Novas categorias, funcionalidades otimizadas e mais segurança para suas compras internacionais."
        imageUrl="https://readdy.ai/api/search-image?query=Modern%20spreadsheet%20interface%20on%20large%20monitor%20displaying%20colorful%20data%20charts%20and%20product%20listings%2C%20minimal%20desk%20with%20succulent%20plant%2C%20bright%20workspace%2C%20tech%20startup%20vibe%2C%20clean%20modern%20office%20photography&width=1600&height=700&seq=artv2-atualizacoes&orientation=landscape"
        slug="/artigo/atualizacoes-hoobuyspreadsheet"
      />
      <ArticleLayout
        tag="Novidades &bull; 2026"
        title="Atualizações do HoobuySpreadsheet em 2026: O Que Mudou e Melhorou"
        description="Fique por dentro de todas as atualizações e melhorias do Hoobuy Spreadsheet em 2026. Novas categorias, funcionalidades otimizadas e mais segurança para suas compras internacionais."
        imageUrl="https://readdy.ai/api/search-image?query=Modern%20spreadsheet%20interface%20on%20large%20monitor%20displaying%20colorful%20data%20charts%20and%20product%20listings%2C%20minimal%20desk%20with%20succulent%20plant%2C%20bright%20workspace%2C%20tech%20startup%20vibe%2C%20clean%20modern%20office%20photography&width=1600&height=700&seq=artv2-atualizacoes&orientation=landscape"
        imageAlt="Atualizações HoobuySpreadsheet 2026"
      >
        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            2026: Um Ano de Grandes Melhorias
          </h2>
          <p className="text-foreground-600 leading-relaxed mb-3">
            O <strong>Hoobuy Spreadsheet</strong> não para de evoluir. Em 2026, implementamos diversas melhorias baseadas no feedback da nossa comunidade de compradores. Desde a reorganização das categorias até a otimização dos filtros de busca, cada atualização foi pensada para tornar sua experiência de compra ainda mais fluida e segura.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            Principais Novidades
          </h2>
          <div className="space-y-4">
            {[
              { icon: 'ri-speed-up-line', title: 'Performance Otimizada', text: 'A planilha agora carrega 3x mais rápido. Navegação entre categorias é instantânea, mesmo com centenas de produtos listados simultaneamente.' },
              { icon: 'ri-filter-3-line', title: 'Novos Filtros de Busca', text: 'Implementamos filtros avançados por faixa de preço, popularidade e data de adição. Encontre exatamente o que procura em segundos.' },
              { icon: 'ri-shield-star-line', title: 'Selo de Verificação', text: 'Produtos com selo verde passaram por dupla verificação. Isso significa garantia extra de qualidade e segurança na compra.' },
              { icon: 'ri-group-line', title: 'Comunidade Expandida', text: 'Crescemos para mais de 10.000 usuários ativos. A comunidade HoobuySpreadsheet é hoje a maior rede de compradores inteligentes do Brasil.' },
            ].map(item => (
              <div key={item.icon} className="flex gap-4 p-4 rounded-xl bg-accent-50 border border-accent-200">
                <div className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-foreground-950 w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            O Que Esperar nos Próximos Meses
          </h2>
          <p className="text-foreground-600 leading-relaxed mb-3">
            A equipe do <strong>HoobuySpreadsheet</strong> já está trabalhando em novas funcionalidades, incluindo alertas personalizados de queda de preço e integração com apps de mensagens. Fique ligado — o melhor ainda está por vir!
          </p>
        </section>
      </ArticleLayout>
    </>
  );
}